/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB, pxToEmWithBaseline, replacePXinStringWithEM, color, textShadow } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// BUTTON STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	submit: {
		border: '0',
		borderRadius: pxToEm(3),
		cursor: 'pointer',
		display: 'block',
		fontSize: pxToEm(14),
		fontWeight: '500',
		lineHeight: '1',
        height: pxToEmWithBaseline({ value: 32, fontSizeBaseline: 14 }),
        width: pxToEmWithBaseline({ value: 100, fontSizeBaseline: 14 }),
		maxWidth: pxToEm(400),
		padding: replacePXinStringWithEM('10px 0 13px'),
		extend: textShadow.medium,
        backgroundColor: color.white,
        color: 'rgb(23, 60, 128)',
        textShadow: 'none',
        textTransform: 'none',
        transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
        animationName: 'fadeInLeft',
        animationDelay: '0.3s',
        animationDuration: '.4s',
        animationFillMode: 'forwards',
        '&:hover': { backgroundColor: convertHexToRGB(color.white, 90) },
		transition: 'background .2s linear 0s',
        '&:disabled': {
            cursor: 'default',
            pointerEvents: 'none',
			color: '#808080',
            '&:hover': { backgroundColor: color.white }
        },
	}
};
